module.exports = __webpack_public_path__ + "img/medpage_today_plugin.986404b1.svg";